<template>
  <v-row id="heading-6" class="">
    <v-col cols="12" sm="2" class="secondary"></v-col>
    <v-col cols="12" sm="8" class="secondary px-10 px-lg-16">
      <h1 class="pt-15 primary--text title-font text-lg-h4 text-md-h4 pr-md-16">
        {{ $t("titleContactanos") }}
      </h1>
      <h4
        class="support--text body-font pt-8 pb-16 font-weight-medium pr-md-10"
      >
        {{ $t("subtitleContactanos") }}
      </h4>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              filled
              color="primary"
              :placeholder="$t('lblNombre')"
              dense
              v-model="item.name"
              :rules="noEmptyRules"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              filled
              color="primary"
              :placeholder="$t('lblTelefono')"
              dense
              v-model="item.phoneNumber"
              :rules="noEmptyRules"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              filled
              color="primary"
              :placeholder="$t('lblCorreo')"
              dense
              v-model="item.email"
              :rules="emailRules"
            >
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="8"
            class="mb-16 font-weight-medium text-body-1 body-font"
          >
            <div class="mb-3">
              <small
                class="font-weight-medium text-body-1 body-font support--text"
              >
                Mario — 5748-5870 — dedcagt@gmail.com
              </small>
            </div>
            <div class="mb-3">
              <small
                class="font-weight-medium text-body-1 body-font support--text"
              >
                Marili — 3025-7888 — dedca2gt@gmail.com
              </small>
            </div>
            <div class="mb-3">
              <small
                class="font-weight-medium text-body-1 body-font support--text"
              >
                informacion@dedcalatam.com
              </small>
            </div>
            <div>
              <small
                class="font-weight-medium text-body-1 body-font support--text"
              >
                {{ $t("lblDireccion") }}
              </small>
            </div>
          </v-col>
          <v-col cols="12" md="4" class="mb-16 d-flex justify-end align-end">
            <v-btn
              large
              :block="$vuetify.breakpoint.xs"
              color="primary"
              elevation="0"
              @click="sendMessageContact"
              :loading="loading"
            >
              {{ $t("btnEnviar") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-col>
    <v-col cols="12" sm="2" class="secondary"></v-col>
  </v-row>
</template>

<script>
import { contactanos } from "@/api";
import { messages } from "@/utils";
export default {
  name: "ContactUs",
  data: function () {
    return {
      loading: false,
      item: {
        name: "",
        email: "",
        phoneNumber: "",
      },
      emailRules: [
        (value) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) ||
          this.$t("lblValidEmail"),
      ],
      noEmptyRules: [(value) => !!value || this.$t("lblCompletaDato")],
    };
  },
  methods: {
    recaptcha() {
      return new Promise((resolve) => {
        this.$recaptchaLoaded().then(() => {
          this.$recaptcha("contactanos").then((token) => {
            resolve(token);
          });
        });
      });
    },
    async sendMessageContact() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      const token = await this.recaptcha();
      const data = {
        ...this.item,
        reason: "Contacto desde la página web",
        comment: `Teléfono: ${this.item.phoneNumber}`,
        token,
      };
      const { error } = await contactanos(data);
      this.loading = false;
      if (error) {
        messages.error(this.$t("msgContactError"));
      } else {
        messages.success(this.$t("msgContactSuccess"));
        this.clearForm();
      }
    },
    clearForm() {
      this.item = {
        name: "",
        email: "",
        phoneNumber: "",
      };
      this.$refs.form.reset();
    },
  },
};
</script>
<style scoped src="@/assets/css/home.css"></style>
<style scoped>
.cover-contact-us {
  min-height: 90vh;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center bottom;
  background-image: url("~@/assets/images/image_people.jpg") !important;
}
</style>
